import { Component } from "react";
import { handleStaleClientFailure, isStaleClientError } from "../../utils/staleClientRecovery";
import StaleClientPrompt from "./StaleClientPrompt";

export default class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    handleStaleClientFailure(error);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    if (isStaleClientError(error)) {
      return (
        <div className="stale-client-page">
          <StaleClientPrompt />
        </div>
      );
    }

    return (
      <div className="stale-client-page" role="alert">
        <h2 className="stale-client-prompt__title">Something went wrong</h2>
        <p className="stale-client-prompt__body">
          Try refreshing the page. If the problem continues, contact support.
        </p>
        <button
          type="button"
          className="stale-client-prompt__btn"
          onClick={() => window.location.reload()}
        >
          Refresh
        </button>
      </div>
    );
  }
}
